export default __webpack_public_path__ + "static/media/Votanthic Raiment.23419a12.jpg";